<template>
    <div class="ma-1">    
        <v-switch v-model="showDeactivated" label="show deactivatd" />         
         <v-treeview dense :items="items" >
            <template v-slot:label="{ item }">
                <category-node :value="item" @childNodeAdded="childAdded" />             
            </template>                       
         </v-treeview>         
    </div>
</template>

<script>
    import CategoryNode from '@/components/CategoryNode';
    export default {
        name: 'Categories',
        props: [],
        components: {CategoryNode},
        data: function() {
            return	{
                showDeactivated : false,
            }
        },


        created(){
        },

        computed:{
            items(){
                let cats = [...this.$store.state.categories];
                if(!this.showDeactivated){
                    cats = cats.filter(item=>item.CAT_INACTIVE != 1);
                }
                let result = [];
                let rootCats = this.findRootCateories(cats);
                rootCats.map(rootCat=>{
                    let node = this.makeTreeNode(rootCat);
                    result.push(node);
                });
                
                let unhandled = this.BuildTree(result,cats);
                while(unhandled.length > 0){             
                    unhandled = this.BuildTree(result,unhandled);
                }
                
                return result;
            },
        },

        watch:{
        },

        methods:{   
         
            childAdded(child){
               let node = this.makeTreeNode(child); 
               let parent = this.findParent(this.items,node);
               if(parent){
                   parent.children.push(node);
               }
            },

            findRootCateories(categories){
                let result = [];
                categories.map(category=>{                                      
                    if(category.CAT_PARENT_ID == null){
                        result.push(category);                     
                    }
                })
                return result.sort((a,b)=>{
                    return ('' + a.CAT_NAME).localeCompare(b.CAT_NAME)
                });
            },

            BuildTree(tree,nodes){
                let nodesWithoutParents = [];                
                nodes.map(category=>{
                    if(category.CAT_PARENT_ID != null){
                        let node = this.makeTreeNode(category);
                        let parent = this.findParent(tree,node);  
                        if(parent){        
                            parent.children.push(node);
                            parent.children = parent.children.sort((a,b)=>{
                                return a.category.CAT_SORT - b.category.CAT_SORT;
                            });                            
                        } else{
                            nodesWithoutParents.push(category);
                        }
                    }
                                        
                });
                return nodesWithoutParents;
            },
            

            findParent(tree,node){
              let result = null;
              //parent is root item?
              result = tree.find(item=>item.id == node.category.CAT_PARENT_ID);
              if(result){
                  return result;
              }
              //check child items of all root items
              for (let index = 0; index < tree.length; index++) {
                  const item = tree[index];
                  if(item && item.children.length > 0){
                      result = this.findParent(item.children,node);
                      if(result){
                          return result;
                      }
                  }
              }            
              return result;
            },

      

            makeTreeNode(category){                
                return {
                    id:category.CAT_ID,            
                    name:category.CAT_NAME,
                    categoryName : category.CAT_NAME,
                    category : JSON.parse(JSON.stringify(category)),                                  
                    children:[], 
                }
            },

           

            
        },
    }
</script>

<style scoped>

</style>
